import React from 'react'

import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'

import { Button, Dialog, Icon } from 'src/chrome'
import { useEffect, useState } from 'src/hooks'

import { Group } from '../../contactTypes'
import styles from './groupEditForm.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'

type Props = {
  title: string
  onClose: () => void
  onSubmit: (group: Group) => void
  group: Group
}

const GroupEditForm: React.FC<Props> = props => {
  const { title, onClose, onSubmit, group } = props

  const [name, setName] = useState(group.name)
  const [description, setDescription] = useState(group.description ?? '')

  useEffect(() => {
    setName(group.name)
    setDescription(group.description ?? '')
  }, [group])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    onSubmit({
      id: group.id,
      name,
      description,
    })
  }

  return (
    <Dialog disableBackdropClick={true} open={true} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          <Text type="caption" color="primaryHeading">
            {title}
          </Text>
          <Icon
            icon={'CLOSE'}
            className={styles.close}
            color={'#6f8394'}
            size={18}
            onClick={onClose}
          />
        </DialogTitle>
        <DialogContent className={styles.modalContainer}>
          <TextField
            name={'name'}
            value={name}
            label={'Group Name'}
            InputLabelProps={{
              shrink: true,
              style: { color: '#000' },
            }}
            required={true}
            fullWidth={true}
            onChange={e => setName(e.target.value)}
          />
          <TextField
            name={'description'}
            value={description}
            label={'Description'}
            InputLabelProps={{
              shrink: true,
              style: { color: '#000' },
            }}
            required={false}
            fullWidth={true}
            multiline={true}
            onChange={e => setDescription(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            type={'submit'}
            title="Save Group"
            buttonColor="pink"
            style={{
              height: '29px',
              lineHeight: '29px',
              margin: '0 auto',
            }}
          />
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default GroupEditForm
